/**
 * Bloqueia pinch-zoom e double-tap-zoom no iOS Safari, que ignora
 * user-scalable=no da meta viewport por razões de acessibilidade.
 */
export function installNoZoom(): void {
  if (typeof document === 'undefined') return;

  const preventGesture = (e: Event) => e.preventDefault();
  document.addEventListener('gesturestart', preventGesture);
  document.addEventListener('gesturechange', preventGesture);
  document.addEventListener('gestureend', preventGesture);

  let lastTouchEnd = 0;
  document.addEventListener(
    'touchend',
    (e) => {
      const now = Date.now();
      if (now - lastTouchEnd <= 300) e.preventDefault();
      lastTouchEnd = now;
    },
    { passive: false },
  );

  // Bloqueia pinch (2 dedos) em qualquer área da página.
  document.addEventListener(
    'touchmove',
    (e) => {
      if (e.touches.length > 1) e.preventDefault();
    },
    { passive: false },
  );
}
